<template>
  <div class="r-chooseAddress common-hover" @click="addAddress">
    <!-- <div class="iconfont iconzengjiashuliang"></div> -->
    <div class="md-add">
      <Icon type="md-add" />
    </div>
    <div class="title">{{ $t("address.addTitlt") }}</div>
    <div class="addContent">{{ $t("address.addContent") }}</div>
  </div>
</template>

<script>
export default {
  name: "r-chooseAddress",
  data() {
    return {};
  },
  methods:{
    // 新增地址
    addAddress(){
      this.$emit('addAddress')
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-chooseAddress {
  width: 325px;
  height: 220px;
  border: 1px dashed rgba(8, 25, 56, 0.4);
  .md-add {
    font-size: 29px;
    color: #9ca3af;
    margin: 58px auto 23px;
  }
  .title {
    opacity: 0.7;
    font-size: 14px;
    font-family: Roboto, Roboto-Medium;
    font-weight: 500;
    text-align: center;
    color: #081938;
    line-height: 16px;
    margin: 0 auto 10px;
  }
  .addContent {
    width: 239px;
    height: 27px;
    opacity: 0.4;
    font-size: 12px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: center;
    color: #081938;
    line-height: 14px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-chooseAddress.vue